// types
import { createSlice } from '@reduxjs/toolkit';
import type { AuthState } from 'store/types';
import type { PayloadAction } from '@reduxjs/toolkit';

// initial state
export const initialState: AuthState = {
    isAuthenticated: false,
    auth: {
        token_type: null,
        expires_in: null,
        access_token: null,
        refresh_token: null,
        expires_at: null,
    },
    user: {
        id: undefined,
        status: 'online',
        username: undefined,
        firstname: 'Q.Live',
        lastname: 'Nutzer',
        image: undefined,
        email: '',
        roles: [],
        last_password_change: undefined,
    },
};

// ==============================|| SLICE - MENU ||============================== //

const auth = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuth(state, action: PayloadAction<AuthState['auth']>) {
            if (!action.payload) {
                state.isAuthenticated = false;
                state.auth = undefined;
                return;
            }
            state.isAuthenticated =
                (action.payload.access_token?.length || 0) > 0;

            state.auth = action.payload;
            const t = new Date();
            t.setSeconds(t.getSeconds() + (action.payload.expires_in! - 600)); // can be safely assumed
            if (state.auth) state.auth.expires_at = t.getTime();
        },

        setUser(state, action) {
            state.user = { ...state.user, ...action.payload };
        },

        clearAuth(state) {
            state.isAuthenticated = false;
            state.auth = initialState.auth;
            state.user = initialState.user;
        },
    },
});

export default auth.reducer;

export const { setAuth, setUser, clearAuth } = auth.actions;
